import { Convocatoria } from "../ConvocatoriasModel/convocatoria.model";

export interface DocumentosBEPS {
  nombre: string;
  tipo_documento: string;
  descripcion: string;
  url_documento: string;
  documentacion: Array<arrayDocumentos>;
  editar: boolean;
  index: number;
  file: string;
  filename: string;
  tipo_documento_file: string;
  pdf: string;
  namepdf: string;
  convocatoria: Array<Convocatoria>;
}

interface arrayDocumentos {
  index: number;
  nombre: string;
  tipo_documento: string;
  descripcion: string;
  url_documento: string;
  activo: boolean;
}

export const initialValuesDocumentosBEPS = {
  nombre: "",
  tipo_documento: "",
  descripcion: "",
  url_documento: "",
  documentacion: [],
  editar: false,
  index: 0,
  file: "",
  filename: "",
  tipo_documento_file: "",
  pdf: "",
  namepdf: "",
  convocatoria: [],
};
